import { Dispatch } from 'redux';

export async function loadPage(dispatch: Dispatch<any>): Promise<void> {
    return Promise.resolve();
}